// @flow

import React, {useState, useEffect} from "react";
import {useObserver} from "mobx-react-lite";
import {Col, Row, Table, Popover} from "antd";
import {useHistory} from "react-router-dom";
import {SearchOutlined, InfoCircleOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {TableContainer} from "./../companyPageStyles";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {
    CloseIcon,
    SearchInput
} from "../../_defaultComponents/FilterComponents/FilterComponentStyles";
import JSONInput from "react-json-editor-ajrm";
import moment from "moment";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";

const {Column} = Table;

export const FalseCompanyRecords = () => {
    const history = useHistory();
    const stores = useStore();
    const {t} = useTranslation(["companyPage"]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState(
        new URLSearchParams(history.location.search).get("searchText")
    );
    const [text, setText] = useState("");
    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.companyStore.getFalseCompanyRecordList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            searchText: searchText && searchText.toLocaleLowerCase("tr-TR")
        }),
        dependencies: [currentPage, searchText]
    });

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(history.location.search);
        const urlPage = urlSearchParams.get("page");
        const urlSearchText = urlSearchParams.get("searchText");
        setTimeout(() => {
            if (urlPage) {
                const page = parseInt(urlPage);
                if (!isNaN(page)) setCurrentPage(page);
            }
            if (urlSearchText) {
                setSearchText(urlSearchText);
                setText(urlSearchText);
            }
        });
    }, []);

    useEffect(() => {
        if (stores.meStore.checkRole("notVisibleForCompanyUser")) {
            setUrl();
        }
    }, [currentPage, searchText]);

    const setUrl = () => {
        let path = history.location.pathname;
        if (currentPage) {
            path += "?page=" + currentPage;
        }
        if (searchText) {
            path += "&searchText=" + searchText;
        }
        history.push(path);
    };

    return useObserver(() => (
        <div data-testid="companyScreen">
            <Row
                type="flex"
                justify="space-between"
                data-testid="filterCard"
                style={{
                    width: "100%",
                    heigh: "100%"
                }}
            >
                {/* TEXT-SEARCH Disabled for now 
                <Col lg={24} xl={18} xxl={20}>
                    <Row type="flex" gutter={[20, 20]} data-testid="filterCard">
                        <Col xs={20} sm={16} md={12} lg={8} xl={6} span={5}>
                            <SearchInput
                                placeholder={t("filters.search", {ns: "common"})}
                                value={text}
                                data-testid="searchInput"
                                onSearch={value => {
                                    setCurrentPage(1);
                                    setSearchText(value);
                                }}
                                onChange={event => {
                                    setText(event.target.value);
                                }}
                                enterButton={
                                    <CustomButton
                                        data-testid="searchInput_searchButton"
                                        icon={<SearchOutlined />}
                                    />
                                }
                                suffix={
                                    text ? (
                                        <CloseIcon
                                            data-testid="searchInput_deleteButton"
                                            onClick={() => {
                                                setCurrentPage(1);
                                                setSearchText("");
                                                setText("");
                                            }}
                                        />
                                    ) : (
                                        <span />
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col> 
                */}
            </Row>
            <TableContainer
                loading={loading}
                dataSource={data.rows}
                rowKey="_id"
                data-testid="companyTable"
                pagination={{
                    total: data.dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                }}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                scroll={{x: "max-content"}}
                display={data?.rows?.length > 0 ? "grid" : "flex"}
                dataTitles={[
                    t("fields.companyName", {ns: "common"}),
                    t("fields.city", {ns: "common"}),
                    t("fields.county", {ns: "common"})
                ]}
            >
                <Column
                    title={t("fields.companyName", {ns: "common"})}
                    dataIndex="companyName"
                    render={text => <span data-testid="companyName">{text}</span>}
                />
                <Column
                    title={t("fields.city", {ns: "common"})}
                    dataIndex="city"
                    render={text => <span data-testid="companyName">{text?.capitalize()}</span>}
                />
                <Column
                    title={t("fields.county", {ns: "common"})}
                    dataIndex="county"
                    render={text => <span data-testid="county">{text?.capitalize()}</span>}
                />
                <Column
                    title={t("fields.createdDate", {ns: "common"})}
                    dataIndex="createdAt"
                    render={createdAt => (
                        <span data-testid="county">
                            {createdAt ? moment(createdAt).format("DD.MM.YYYY HH:mm:ss") : "-"}
                        </span>
                    )}
                />
                <Column
                    title={"Detay"}
                    dataIndex="county"
                    render={(text, row) => (
                        <Popover
                            content={
                                <JSONInput
                                    id="courierLogGPSProviderJSON"
                                    placeholder={row}
                                    theme="dark_mitsuketa_tribute"
                                    width="auto"
                                    height="auto"
                                    viewOnly={true}
                                    confirmGood={false}
                                />
                            }
                        >
                            <InfoCircleOutlined />
                        </Popover>
                    )}
                />
            </TableContainer>
        </div>
    ));
};
